import { Col, Container, Row } from "react-bootstrap";
import "./sparc/style.css";


export default function SparcSymp() {
    return (
    <Container className="portfolio justified-content">
        <br/>
        <br/>
	  <Row>
        
		<Col sm="12">
			<div align="center">
            
                <Row>
                    <Col sm="4"><img src={process.env.PUBLIC_URL+'/sparc/iitlogo.png'} style={{maxWidth:"100%"}}/></Col>
                    <Col sm="4"><img src={process.env.PUBLIC_URL+'/sparc/sparclogo.png'} style={{maxWidth:"100%"}}/></Col>
                    <Col sm="4"><img src={process.env.PUBLIC_URL+'/sparc/rmitlogo.png'} style={{maxWidth:"100%"}}/></Col>  
                </Row>
                
                <h5>SPARC Project Symposium</h5>
                
                <h6>Jointly organized by IIT Delhi & RMIT Melbourne</h6>
                
                <img src={process.env.PUBLIC_URL+'/sparc/symplogo.png'} style={{maxWidth:"15%"}}/>
                
                <h3 style={{marginTop:"5px"}}>Health Co-Design for Community Wellbeing</h3>
                
                <h6>25-26 March 2025</h6>
                
                <h6>Research & Innovation Park, IIT Delhi</h6>
                
            </div>

            <br/>
            <p className="section-heading"><b>Background</b></p> 
            <p>Health co-design, a participatory approach that integrates diverse perspectives in shaping healthcare solutions, is emerging as a transformative strategy for enhancing community well-being. In India, rural communities have rich traditions of self-care, traditional medicine, and holistic well-being practices. However, gaps persist in integrating these approaches with modern healthcare systems. This symposium seeks to bridge this gap by bringing together experts in rural development, health co-design, traditional medicine, yoga, and community health to foster inclusive and innovative health solutions.</p>
            <p>The 2-day Symposium <b>“Health Co-Design for Community Well-Being”</b> is motivated by a desire to share outcomes of reflections and research, that are in the form of knowledge formulations that can support not only the community but the entire ecosystem of stakeholders in managing the challenges presented by specific health care conditions, such as diabetes. This symposium brings together scholars and experts in rural development (IIT Delhi), Health Codesign (RMIT Australia), traditional health practitioners (Sanjeevani Ayurveda, Swad Aur Sehat and others) Community Health Practitioners (JNU, New Delhi), Civil Society organisations (United Way Health & PATH, India) and several committed to develop a community owned approach to improve the health of rural communities. The symposium constitutes an effort to co-learn and co-design various perspectives including the role that vernacular and traditional knowledge systems can play in delivering improved health outcomes for rural communities.</p>

            <p className="section-heading"><b>Objectives of the Symposium</b></p>
            <ol>
                <li>To explore the role of co-design in strengthening rural health systems and well-being.</li>
                <li>To facilitate cross-learning among diverse stakeholders, including traditional and modern health practitioners.</li>
                <li>To showcase innovative health interventions and models of participatory healthcare design.</li>
                <li>To build collaborative networks for future action in community health and well-being.</li>
            </ol>

            <p className="section-heading"><b>Who Should Attend</b></p>
            <ul className="bullet">
                <li>Rural Development Practitioners</li>
                <li>Health co-design experts</li>
                <li>Traditional Health practitioners (Ayurveda, Yoga, Siddha, Unani, Folk Healers)</li>
                <li>Yoga experts and wellness practitioners</li>
                <li>Public Health and Community Health Professionals</li>
                <li>Academics and Researchers in Health Innovation</li>
                <li>Policymakers and Government Officials involved in Rural Health</li>
                <li>NGO representatives and Grassroots Health Workers</li>
            </ul>

            <p className="section-heading"><b>Keynote Presentations by Experts</b></p>
            <p>The symposium will feature keynote addresses by leading experts on:</p>
            <ul className="bullet">
                <li>Participatory Health Co-Design: Global and Local Perspectives</li>
                <li>Integrating Traditional and Modern Healthcare Approaches</li>
                <li>The Role of Yoga and Holistic Wellness in Community Health</li>
                <li>Policy and Governance for Inclusive Rural Health Innovation</li>
            </ul>

            <p className="section-heading"><b>Call for Participation</b></p>
            <Row>
                <Col sm="12" md="3">
                    <img src={process.env.PUBLIC_URL+'/sparc/formqr.png'} width="100%"/>
                </Col>
                <Col sm="12" md="9">
                    <p>This symposium will serve as a unique opportunity to foster collaboration, share knowledge, and create actionable strategies for improving community well-being through health co-design. Please visit the <a href="https://forms.gle/2ns7Z4T19YHS7fRs6" target="_blank">Google Form</a> to register for the Symposium.</p>
                </Col>
                
            </Row>

            <p className="section-heading"><b>Symposium Schedule</b></p>
            <p><b>Day One - 25 March 2025 (Tuesday)</b></p>
            <table className="schedule-table">
                <tbody>
                <tr>
                    <td>9:30 am -<br/>10:00 am</td>
                    <td>Registration</td>
                </tr>
                <tr>
                    <td>10:00 am -<br/>10:15 am </td>
                    <td>Opening Remarks by Symposium Coordinators:&nbsp;
                        <a href="https://web.iitd.ac.in/~chariarv" target="_blank">Prof V M Chariar</a>&nbsp;
                        & <a href="https://www.rmit.edu.au/profiles/o/j-oliver" target="_blank">Prof James Oliver</a>&nbsp;
                        <a href="https://youtu.be/ooLf0XLhag4?si=t2hCNEjmYUX3gKLp" target="_blank">Video</a>
                    </td>
                </tr>
                <tr>
                    <td>10:15 am -<br/> 11:00 am </td>
                    <td>
                        Does Ayurveda Have Solutions For Extreme Events Such As The Pandemic? Experiences From COVID19.&nbsp;
                        <a href="https://youtu.be/5j4mgXoEKvQ?si=OY0jmzIIsbjRsHd4" target="_blank">Video</a>&nbsp;
                        <a href={process.env.PUBLIC_URL+'/sparc/DrPLTGirijaAbstract.pdf'} target="_blank">Abstract</a><br/>
                    <a href="https://girijasanjeevani.com/facilitiesandstaff.htm#girija" target="_blank">Dr P L T Girija</a>, Sanjeevani Ayurveda & Yoga Centre, Chennai
                    </td>
                </tr>
                <tr>
                    <td>11:00 am -<br/> 11:45 am </td>
                    <td>
                        Some High Potential Yet Neglected Ayurveda Practices for Community Well-Being.&nbsp;
                        <a href="https://youtu.be/zY-PhNbMZz8?si=ru3FU1ReZdxvksGv" target="_blank">Video</a>&nbsp;
                        <a href={process.env.PUBLIC_URL+'/sparc/AbstractDrCBDesai.pdf'} target="_blank">Abstract</a><br/>
                        <a href="https://www.linkedin.com/in/dr-chandrakant-desai-006167356" target="_blank">Vaidya Dr Chandrakant B Desai</a>, Yadagud, Belagavi, Karnataka 
                    </td>
                </tr>
                <tr>
                    <td>12:00 pm -<br/> 12:30 pm</td>
                    <td>
                        Homeopathy for Health: A Collaborative Path to Personalized Wellness.&nbsp;
                        <a href="https://youtu.be/uYz1EAQ1oxM?si=6I1_VEXlcrX-eF9F" target="_blank">Video</a>&nbsp;
                        <a href={process.env.PUBLIC_URL+'/sparc/AbstractHardikKhamar.pdf'} target="_blank">Abstract</a><br/>
                        <a href="https://www.linkedin.com/in/dr-hardik-khamar-44036623/" target="_blank">Prof Hardik Khamar</a>, Homeopathy Care, Ahmedabad
                    </td>
                </tr>
                <tr>
                    <td>12:30 pm -<br/> 01:00 pm </td>
                    <td>
                        How Self-Care practices can improve overall individual well-being?&nbsp;
                        <a href="https://youtu.be/cMtnpifvIso?si=VdruUF1XiPsEFuxK" target="_blank">Video</a>&nbsp;
                        <a href={process.env.PUBLIC_URL+'/sparc/AbstractPurnimaArunSPARCSymposium.pdf'} target="_blank">Abstract</a><br/>
                        <a href="https://www.linkedin.com/in/purnima-arun-412a13a8/" target="_blank">Ms Purnima Arun</a>, Swad Aur Sehat, New Delhi
                    </td>
                </tr>
                <tr>
                    <td>1:00 pm -<br/> 2:00 pm </td>
                    <td>Lunch</td>
                </tr>
                <tr>
                    <td>2:00 pm -<br/> 2:30 pm </td>
                    <td>Health x Design: Shaping What Shapes Us&nbsp;
                    <a href="https://youtu.be/lqARkn2Vc38?si=TKVT-PJ8QiVMbG0p" target="_blank">Video</a><br/>
                        <a href="https://www.linkedin.com/in/aditi-singh-66817555/" target="_blank">Prof Aditi Singh</a>, SPA New Delhi
                    </td>
                </tr>
                <tr>
                    <td>2:30 pm -<br/> 3:15 pm </td>
                    <td>
                        People and Things: Designing within Socio-Technical Systems&nbsp;
                        <a href="https://youtu.be/1vhTWrRGrMc?si=3Y5LcQV0971BPPFd" target="_blank">Video</a><br/>
                        <a href="https://www.rmit.edu.au/profiles/f/liam-fennessy" target="_blank">Prof Liam Fennessy</a>, RMIT Melbourne, Australia
                    </td>
                </tr>
                <tr>
                    <td>3:15 pm -<br/> 3:30 pm</td>
                    <td>
                        Juice
                    </td>
                </tr>
                <tr>
                    <td>3:30 pm -<br/> 4:30 pm</td>
                    <td>Panel Discussion with Questions from Delegates <a href="https://youtu.be/VOMSVqOLo8A?si=ymbWa4CIWJ-uuFrt" target="_blank">Video</a>
                    </td>
                </tr>
                
                </tbody>
            </table>

            <br/>
            <p><b>Day Two - 26 March 2025 (Wednesday)</b></p>
            <table className="schedule-table">
                <tbody>
                
                <tr>
                    <td>10:00 am -<br/> 10:15 am </td>
                    <td>Opening Remarks by Symposium Coordinators:&nbsp;
                    <a href="https://web.iitd.ac.in/~chariarv" target="_blank">Prof V M Chariar</a> &&nbsp;
                    <a href="https://www.rmit.edu.au/profiles/o/j-oliver" target="_blank">Prof James Oliver</a>&nbsp;
                    <a href="https://youtu.be/zVxADzPHjQM?si=ZvKwZInlv671eMYX" target="_blank">Video</a>
                        
                    </td>
                </tr>
                <tr>
                    <td>10:15 am -<br/> 11:00 am </td>
                    <td>
                        How do we design a health system that allows for integration of plural knowledge?&nbsp;
                        <a href="https://youtu.be/Sj-j67HicaQ?si=9R3Dt1ToWaP9XDqo" target="_blank">Video</a>&nbsp;
                        <a href={process.env.PUBLIC_URL+'/sparc/AbstractRituPriyaSPARCSymposium.pdf'} target="_blank">Abstract</a><br/>
                        <a href="https://www.jnu.ac.in/content/ritupriya" target="_blank">Prof Ritu Priya Mehrotra</a> (Retired), Centre of Social Medicine and Community Health, JNU 
                    </td>
                </tr>
                <tr>
                    <td>11:00 am -<br/> 11:30 am </td>
                    <td>
                        Seeing with Both Eyes : Integrating Traditional and Modern Approaches to Health.&nbsp;
                        <a href="https://youtu.be/OAqHENIMxj0?si=GpbaHo27esx6WLCp" target="_blank">Video</a>&nbsp;
                        <a href={process.env.PUBLIC_URL+'/sparc/AbstractDrRashmi.pdf'} target="_blank">Abstract</a><br/>
				        <a href="https://www.linkedin.com/in/dr-rashmi-raut-gadgil-703230356/" target="_blank">Dr Rashmi Gadgil</a>, Kolhapur
                    </td>
                </tr>
                <tr>
                    <td>11:30 am -<br/> 12:00 pm</td>
                    <td>
                    Women are Nutrition Gatekeepers of Society.&nbsp;
                        <a href="https://youtu.be/1Uu1U4C8zTg?si=xDmmEG_ZW2GKWqp4" target="_blank">Video</a>&nbsp;
                        <a href={process.env.PUBLIC_URL+'/sparc/AbstractSujeetRanjan.pdf'} target="_blank">Abstract</a><br/>
				        <a href="https://www.linkedin.com/in/sujeet-ranjan-phd/" target="_blank">Sujeet Ranjan</a>, CEO, United Way of Delhi, New Delhi
                    </td>
                </tr>
                <tr>
                    <td>12:00 pm -<br/> 12:30 pm </td>
                    <td>
                        How to use the Living Labs approach to co-create impactful health solutions for low resource settings&nbsp;
                        <a href="https://youtu.be/b7Ib2hJ_EeI?si=bF4A62PyboiMIPOI" target="_blank">Video</a>&nbsp;
                        <a href={process.env.PUBLIC_URL+'/sparc/AbstractKGVenkat.pdf'} target="_blank">Abstract</a><br/>
				        <a href="https://www.linkedin.com/in/kg-venkateswaran-64293520/" target="_blank">K G Venkateswaran</a>, Strategy Lead, PATH
                    </td>
                </tr>
                <tr>
                    <td>12:30 pm -<br/> 1:00 pm </td>
                    <td>Panel Discussion with Delegate Questions&nbsp;
                        <a href="https://youtu.be/MKdseYXv2A8?si=deHk23Az_6otzjxC" target="_blank">Video</a>
                    </td>
                </tr>
                <tr>
                    <td>1:00 pm -<br/> 2:00 pm </td>
                    <td>Lunch</td>
                </tr>
                <tr>
                    <td>2:00 pm -<br/> 2:30 pm </td>
                    <td>
                        Co(re)-Designing with Specialists&nbsp;
                        <a href="https://youtu.be/4eqjn6cwVw4?si=UbJyl8HUAjsOheRU" target="_blank">Video</a><br/>
                        <a href="https://www.linkedin.com/in/paraganand/" target="_blank">Prof Parag Anand</a>, SPA, New Delhi
                    </td>
                </tr>
                <tr>
                    <td>2:30 pm -<br/> 3:15 pm</td>
                    <td>Our Human Ecological and Ethical Relations&nbsp;
                    <a href="https://youtu.be/BDEwRKOH-e8?si=xTokZ-H_1IPHr3Db" target="_blank">Video</a><br/>
                    <a href="https://www.rmit.edu.au/profiles/o/j-oliver" target="_blank">Prof James Oliver</a>, RMIT, Melbourne

                    </td>
                </tr>
                <tr>
                    <td>3:15 pm -<br/>3:30 pm</td>
                    <td>
                        Juice
                    </td>
                </tr>
                <tr>
                    <td>3:30 pm -<br/> 4:30 pm</td>
                    <td>
                        Symposium Summary by Rapporteurs & Valedictory Session&nbsp; 
                        <a href="https://youtu.be/kRRLjW1_ZEY?si=yzaq3ND2DAlBiW5d" target="_blank">Video</a><br/>
                        <a href="https://web.iitd.ac.in/~chariarv" target="_blank">Prof Vijayaraghavan M Chariar</a>, CRDT, IIT Delhi
                    </td>
                </tr>
                </tbody>
            </table>

            <br/>
            <br/>

            <p className="section-heading"><b>Symposium Videos</b></p>
            <Row>
                <Col sm="12" md="4">
                    <div className="video-container" style={{marginBottom:"20px"}}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/ooLf0XLhag4?si=j9yX_UeA0R_OD1MM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </Col>
                <Col sm="12" md="4">
                    <div className="video-container" style={{marginBottom:"20px"}}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/5j4mgXoEKvQ?si=ZaG5FAGpLXTV4Vtt" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </Col>
                <Col sm="12" md="4">
                    <div className="video-container" style={{marginBottom:"20px"}}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/zY-PhNbMZz8?si=87QFthylXzyyeszM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>    
                    </div>
                </Col>

                <Col sm="12" md="4">
                    <div className="video-container" style={{marginBottom:"20px"}}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/uYz1EAQ1oxM?si=NKbgfXcvTmq3_u6d" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </Col>
                <Col sm="12" md="4">
                    <div className="video-container" style={{marginBottom:"20px"}}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/cMtnpifvIso?si=4IavApfoqfwbBqAI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </Col>
                <Col sm="12" md="4">
                    <div className="video-container" style={{marginBottom:"20px"}}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/lqARkn2Vc38?si=ug1bZnZE6Eqkuxz3" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </Col>

                <Col sm="12" md="4">
                    <div className="video-container" style={{marginBottom:"20px"}}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/1vhTWrRGrMc?si=-YT-MF9L4q1Dkec8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </Col>
                <Col sm="12" md="4">
                    <div className="video-container" style={{marginBottom:"20px"}}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/VOMSVqOLo8A?si=5gZZf8bjVN3ZhK2g" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </Col>
                <Col sm="12" md="4">
                    <div className="video-container" style={{marginBottom:"20px"}}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/zVxADzPHjQM?si=srPXIg86-ynNPyiI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </Col>

                <Col sm="12" md="4">
                    <div className="video-container" style={{marginBottom:"20px"}}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/Sj-j67HicaQ?si=y0vSY7neglgiM9nJ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </Col>
                <Col sm="12" md="4">
                    <div className="video-container" style={{marginBottom:"20px"}}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/OAqHENIMxj0?si=f4BNtmncYrqhIgLq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </Col>
                <Col sm="12" md="4">
                    <div className="video-container" style={{marginBottom:"20px"}}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/1Uu1U4C8zTg?si=Z0TPVyYo-zmCYDFP" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </Col>

                <Col sm="12" md="4">
                    <div className="video-container" style={{marginBottom:"20px"}}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/b7Ib2hJ_EeI?si=fqBaPIStp8IDSw--" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </Col>
                <Col sm="12" md="4">
                    <div className="video-container" style={{marginBottom:"20px"}}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/MKdseYXv2A8?si=qAgADHFh5OpJlOOP" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </Col>
                <Col sm="12" md="4">
                    <div className="video-container" style={{marginBottom:"20px"}}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/4eqjn6cwVw4?si=Ywr9g0HEKIQxI1_o" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </Col>

                <Col sm="12" md="4">
                    <div className="video-container" style={{marginBottom:"20px"}}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/BDEwRKOH-e8?si=TP0P3h1aDvWHwcLD" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </Col>
                <Col sm="12" md="4">
                    <div className="video-container" style={{marginBottom:"20px"}}>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/kRRLjW1_ZEY?si=g_nSHay76b0nf20r" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </Col>
            </Row>



            <p className="section-heading"><b>Symposium Coordinators</b></p>
            <Row>
                <Col sm="12" md="2">
                    <img src={process.env.PUBLIC_URL+'/sparc/chariar.jpg'} width="100%"/>
                </Col>
                <Col sm="12" md="4">
                    <p>
                        Prof Vijayaraghavan M Chariar<br/>		
                        IIT Delhi<br/>
                        <a href="mailto:chariarv@iitd.ac.in">chariarv@iitd.ac.in</a>
                    </p>
                </Col>

                <Col sm="12" md="2">
                    <img src={process.env.PUBLIC_URL+'/sparc/oliver.jpg'} width="100%" style={{border:"1px solid #ddd"}}/>
                </Col>
                <Col sm="12" md="4">
                    <p>
                        Prof James Oliver<br/>
                        RMIT Melbourne<br/>
                        <a href="mailto:j.oliver@rmit.edu.au">j.oliver@rmit.edu.au</a>
                    </p>
                </Col>
            </Row>
        </Col>
    </Row>
        <br/>
        <br/>
</Container>
    );
}